import { render, staticRenderFns } from "./CumulativeActivityNumber.vue?vue&type=template&id=b5bcff92&scoped=true&"
import script from "./CumulativeActivityNumber.vue?vue&type=script&lang=js&"
export * from "./CumulativeActivityNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bcff92",
  null
  
)

export default component.exports